import { CbhIcon } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

interface BadgePenaltyCounterProps {
  isFilled: boolean;
}

export function BadgePenaltyCounter(props: BadgePenaltyCounterProps) {
  const { isFilled } = props;

  return (
    <Box
      sx={(theme) => {
        const baseStyles = {
          width: 48,
          height: 48,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
        };

        if (isFilled) {
          return {
            ...baseStyles,
            border: `${theme.borderWidth?.thick} solid ${theme.palette.intent?.error.text}`,
          };
        }

        return {
          ...baseStyles,
          border: `${theme.borderWidth?.thick} solid ${theme.palette.border?.primary}`,
        };
      }}
    >
      <CbhIcon
        type="crossed-badge"
        size="medium"
        sx={(theme) => {
          if (isFilled) {
            return { color: theme.palette.intent?.error.text };
          }

          return { color: theme.palette.action.disabled };
        }}
      />
    </Box>
  );
}
